import React, {useContext, useEffect, useState} from 'react';
import {Button, Modal, Result} from "antd";
import {useTranslation} from "react-i18next";
import selector from "@tools/Selectors";
import * as webSocket from "@tools/webSocket/webSocket";
import {GlobalContext} from "@tools/globalContext";
import {stringFormat} from "@tools/format";

const NewVersionModal: React.FC = () => {
    const [showModal, setShowModal] = useState(false);
    const {version} = useContext(GlobalContext);
    const [newVersion, setNewVersion] = useState<string>("")
    const [htmlVersion, setHtmlVersion] = useState<string>("")
    const {t} = useTranslation()

    useEffect(() => {
        const htmlVersion = document.querySelector("body")?.getAttribute("data-version")
        if(htmlVersion && htmlVersion !== version) {
            setHtmlVersion(htmlVersion)
            setShowModal(true)
        }

        let newVersion = webSocket.on("version", (data) => {
            if(version && version !== data.data.value) {
                setNewVersion(data.data.value)
                setShowModal(true)
            }
        });

        return (() => {
            newVersion.off()
        })
    }, [version])


    return (
        <Modal
            centered={true}
            closable={false}
            title={null}
            open={showModal}
            footer={null}
            maskClosable={false}
            mask={true}
            data-test={selector.connectionError.modal}
        >
            <Result
                title={t("newVersion:title")}
                subTitle={stringFormat(htmlVersion ? t("newVersion:htmlDescription") : t("newVersion:description"), [newVersion, htmlVersion || version as string])}
                extra={
                    <Button type="primary" key="console" onClick={() => window.location.reload()}>
                        {t("newVersion:reload")}
                    </Button>
                }
            />

        </Modal>
    )
};

export default NewVersionModal;
